import { Module } from './module';
import type { MCFXTracker } from './declarations';

export class NutshellBoot extends Module {
  constructor(tracker: MCFXTracker) {
    super(tracker);

    if (
      typeof this.tracker.configuration.siteId === 'string' &&
      this.tracker.configuration.siteId.substring(0, 3) === 'ns-'
    ) {
      const id = Number(this.tracker.configuration.siteId.substring(3));
      this.init({nsInstanceId: id});
    }

    // Sep 2025 - support integer siteIds so WebFX-first customers
    // can also get access to the Nutshell Boot snippet / NS chat.
    if (typeof this.tracker.configuration.siteId !== 'undefined' && !isNaN(Number(this.tracker.configuration.siteId))) {
      this.init({siteId: Number(this.tracker.configuration.siteId)});
    }
  }

  init(options: {siteId?: number, nsInstanceId?: number}) {
    if ((window.Nutsheller?.loadedModules ?? []).indexOf?.('boot') !== -1) {
      if (this.tracker.configuration.mode === 'debug') {
        console.log('[RCFX::INFO] Nutshell Boot already loaded');
      }

      return;
    }

    const bootDiv = document.createElement('div');
    const bootDivId = this.getDivId(options);
    bootDiv.id = bootDivId;
    document.body.appendChild(bootDiv);

    const boot = document.createElement('script');
    boot.text = this.getScriptText(bootDivId, {nsInstanceId: options.nsInstanceId, siteId: options.siteId});
    document.getElementById(bootDivId).appendChild(boot);

    const loader = document.createElement('script');
    loader.src = this.getScriptSource(options.nsInstanceId);
    loader.async = true;
    document.getElementById(bootDivId).appendChild(loader);
  }

  getScriptText(targetId: string, options: {siteId?: number, nsInstanceId?: number}) {
    return `
    <!-- Nutshell Boot -->
    (function(n,u,t){n[u]=n[u]||function(){(n[u].q=n[u].q||[]).push(arguments)}}(window,'Nutsheller'));
    Nutsheller('boot', {instance: ${options.nsInstanceId}, siteId: ${options.siteId}, target: '${targetId}', excludedModules: ['analytics']});
    <!-- End Nutshell Boot -->`;
  }

  getScriptSource(instanceId: number) {
    // Instance 1 is the local Nutshell development instance which needs a different source
    return instanceId === 1
      ? 'https://loader.kojo.zone/nutsheller.js'
      : 'https://loader.nutshell.com/nutsheller.js';
  }

  // Use the siteId if it exists, otherwise use the nsInstanceId
  // Returns a string like "nutshell-boot-12345"
  getDivId(options: {siteId?: number, nsInstanceId?: number}) {
    return options.siteId ? `nutshell-boot-${options.siteId}` : `nutshell-boot-${options.nsInstanceId}`;
  }
}

// Add this service to the service type index
declare module './declarations' {
  interface McfxModules {
    ['nutshellBoot']: NutshellBoot;
  }
}
